import BaseAppService from "../../../application/platform/base-app-service";
import PortalAppService from "../../../application/platform/portal-app-service";
import { ACTION_TYPES, useBiddingDispatch, } from "./bidding-context";
import { IListBiddingRequest } from "../../../model/base/request/list-bidding-request";

export const useBiddingController = () => {
    const BiddingDispatch = useBiddingDispatch();
    async function loadData(request: IListBiddingRequest) {
        try {
            const result = await PortalAppService.listBidding(request);
            BiddingDispatch({
                type: ACTION_TYPES.loadingData,
                payload: result,
            });

            const modalities = await BaseAppService.getListModalityBidding();

            BiddingDispatch({
                type: ACTION_TYPES.setModality,
                payload: modalities,
            });

            const status = await BaseAppService.getListBiddingStatus();

            BiddingDispatch({
                type: ACTION_TYPES.setStatus,
                payload: status,
            });
        } catch (error) {
            console.log(error);
        }
    }

    return {
        loadData
    };
}


